/**
 * Redux action types for PIM chat (BM-6229). Kept separate from the devOrder-centric
 * ChatTypes because PIM chat is scoped per Channel Setup, not per dev order.
 */
const PIMChatTypes = {
  SET_ACCESSIBLE_SETUPS: 'PIM_CHAT_SET_ACCESSIBLE_SETUPS',
  SET_SELECTED_SETUP: 'PIM_CHAT_SET_SELECTED_SETUP',
  SET_MESSAGES: 'PIM_CHAT_SET_MESSAGES',
  APPEND_MESSAGE: 'PIM_CHAT_APPEND_MESSAGE',
  UPDATE_MESSAGE: 'PIM_CHAT_UPDATE_MESSAGE',
  SOFT_DELETE_MESSAGE: 'PIM_CHAT_SOFT_DELETE_MESSAGE',
  SET_UNREAD_COUNTS: 'PIM_CHAT_SET_UNREAD_COUNTS',
  INCREMENT_UNREAD: 'PIM_CHAT_INCREMENT_UNREAD',
  CLEAR_UNREAD: 'PIM_CHAT_CLEAR_UNREAD',
  SET_LOADING: 'PIM_CHAT_SET_LOADING',
  SET_ERROR: 'PIM_CHAT_SET_ERROR',
  CLEAR_REDUCER: 'PIM_CHAT_CLEAR_REDUCER',
};

export default PIMChatTypes;
